"use strict";
/**
 * A library to manage colors
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.lighten = exports.darken = exports.getColorDefinition = exports.ToneValue = void 0;
var functional_1 = require("./functional");
var ToneValue;
(function (ToneValue) {
    ToneValue[ToneValue["Darkest"] = 0] = "Darkest";
    ToneValue[ToneValue["Darker"] = 1] = "Darker";
    ToneValue[ToneValue["Dark"] = 2] = "Dark";
    ToneValue[ToneValue["Base"] = 3] = "Base";
    ToneValue[ToneValue["Light"] = 4] = "Light";
    ToneValue[ToneValue["Lighter"] = 5] = "Lighter";
    ToneValue[ToneValue["Lightest"] = 6] = "Lightest";
})(ToneValue = exports.ToneValue || (exports.ToneValue = {}));
// tslint:disable-next-line:no-namespace
(function (ToneValue) {
    function fromString(toneName) {
        toneName = toneName[0].toUpperCase() + toneName.substr(1).toLowerCase();
        // tslint:disable-next-line
        return toneName in ToneValue
            ? ToneValue[toneName]
            : ToneValue.Base;
    }
    ToneValue.fromString = fromString;
})(ToneValue = exports.ToneValue || (exports.ToneValue = {}));
/**
 * Given a color string definition, get the color name and the color tone. For a
 * color with the form `colorName-tone`, it returns {name: colorName, tone:
 * tone}. For a color with the form `colorName`, it returns {name: colorName, tone: base}
 * @param {string} color - the color description
 * @returns {ColorDefinition} the color's name and tone
 *
 */
function getColorDefinition(color) {
    var dashIndex = color.indexOf("-");
    var toneName = dashIndex === -1 ? "base" : color.substring(dashIndex + 1, color.length);
    var tone = ToneValue.fromString(toneName);
    var name = dashIndex === -1 ? color : color.substring(0, dashIndex);
    return { name: name, tone: tone };
}
exports.getColorDefinition = getColorDefinition;
/**
 * Given a color string definition, return the next darker color, or the same color if a darker one
 * can't be found.
 * @param {string} color: A tailwind color string
 *
 */
function darken(color) {
    var _a = getColorDefinition(color), name = _a.name, tone = _a.tone;
    // darken(white) is a special case, since it changes to grey
    if (name === "white")
        return "grey-lightest";
    var nextTone = (0, functional_1.cond)([tone === ToneValue.Base, "dark"], [tone === ToneValue.Dark, "darker"], [tone === ToneValue.Darker, "darkest"], [tone === ToneValue.Lightest, "lighter"], [tone === ToneValue.Lighter, "light"]);
    return name + (nextTone ? "-".concat(nextTone) : "");
}
exports.darken = darken;
/**
 * Given a color string definition, return the next lighter color, or the same color if a darker one
 * can't be found.
 * @param {string} color: A tailwind color string
 *
 */
function lighten(color) {
    var _a = getColorDefinition(color), name = _a.name, tone = _a.tone;
    // lighten(black) is a special case, since it changes to grey
    if (name === "black")
        return "grey-darkest";
    var nextTone = (0, functional_1.cond)([tone === ToneValue.Base, "light"], [tone === ToneValue.Light, "lighter"], [tone === ToneValue.Lighter, "lightest"], [tone === ToneValue.Darker, "dark"], [tone === ToneValue.Darkest, "darker"]);
    return name + (nextTone ? "-".concat(nextTone) : "");
}
exports.lighten = lighten;
